module.exports = __webpack_public_path__ + "img/DE01756.ccea153a.png";